
/*
* DESCRIPTION: add device and client classname to body element.
* REFERENCED FROM: https://gist.githubusercontent.com/devfred/2884711/raw/4bd1e4d3e72b16b570ae0244e5c9ed556fd71815/browser-detect.js
* */

(function( undefined ){
    const body = document.getElementsByTagName('body')[0];

    /* Apple Device Webkit Browsers */
    var isIdevice = /(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent);
    if (isIdevice){
        body.className += ' iphone ipod ipad';
    }
    var isIphone = /(iPhone).*AppleWebKit/i.test(navigator.userAgent);
    if (isIphone){
        body.className += ' iphone';
    }
    var isIpad = /(iPad).*AppleWebKit/i.test(navigator.userAgent);
    if (isIpad){
        body.className += ' ipad';
    }

    /* Android Device Browsers */

    /* Microsoft Browsers */

    /* Mozilla Browsers */

    var BrowserDetect = {
        init: function() {
            this.browser = this.searchString(this.dataBrowser) || 'An unknown browser';
            this.version = this.searchVersion(navigator.userAgent)
                || this.searchVersion(navigator.appVersion)
                || 'an unknown version';
            this.OS = this.searchString(this.dataOS) || 'an unknown OS';
        },
        searchString: function(data) {
            for (let i=0; i<data.length; i++)	{
                let dataString = data[i].string;
                let dataProp = data[i].prop;
                this.versionSearchString = data[i].versionSearch || data[i].identity;
                if (dataString) {
                    if (dataString.indexOf(data[i].subString) !== -1) return data[i].identity;
                }
                else if (dataProp) return data[i].identity;
            }
        },
        searchVersion: function(dataString) {
            let index = dataString.indexOf(this.versionSearchString);
            if (index === -1) return;
            return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
        },
        dataBrowser: [
            {
                string: navigator.userAgent,
                subString: 'Android',
                identity: 'Android'
            },
            {
                string: navigator.userAgent,
                subString: 'Chrome',
                identity: 'Chrome'
            },
            {
                string: navigator.vendor,
                subString: 'Apple',
                identity: 'Safari',
                versionSearch: 'Version'
            },
            {
                string: navigator.userAgent,
                subString: 'Firefox',
                identity: 'Firefox'
            },
            {
                string: navigator.userAgent,
                subString: 'MSIE',
                identity: 'Explorer',
                versionSearch: 'MSIE'
            },
            {
                string: navigator.userAgent,
                subString: 'Trident',
                identity: 'IE11',
                versionSearch: 'rv'
            },
        ],
        dataOS : [
            {
                string: navigator.platform,
                subString: 'Win',
                identity: 'Windows'
            },
            {
                string: navigator.platform,
                subString: 'Mac',
                identity: 'Mac'
            },
            {
                string: navigator.userAgent,
                subString: 'iPhone',
                identity: 'iPhone/iPod'
            }
        ]

    };
    BrowserDetect.init();
    body.className += ' ' + BrowserDetect.browser.toLowerCase();
    // add app class
    const isApp = window.medscape.core.isApp;
    if(isApp) body.className += ' ' + 'app';
})();



// WEBPACK FOOTER //
// ./modules/utils/browser_class.js